/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

import Interp from '../geom/Interp';

const interp = new Interp(0, 0, 0, [
	{ begin: 0, end: 1, first: 0, last: 0.5 },
	{ begin: 1, end: 2, first: 0.5, last: 0.1 },
	{ begin: 2, end: 3, first: 0.1, last: 1.1 },
	{ begin: 3, end: 4, first: 1.1, last: 1.0 },
]);

function calcSpin(time) {
	return interp.get(time) * Math.PI * 2;
}

export default class HeadPingPong extends Phase {
	getPreludeLength() {
		return 0;
	}
	getPostludeLength() {
		return 0;
	}
	run({ time, pulse, headshot_opts }) {
		headshot_opts.rotation[0] = calcSpin(time.relative);
	}
}
